import { useAppSelector } from "@hooks/useTypedRedux";
import { ModalWrapper } from "./ModalWrapper";
import { useAppDispatch } from "@hooks/useTypedRedux";
import { closeModal } from "./genericModalSlice";

export const ModalManager = () => {
  const dispatch = useAppDispatch();
  const {
    isOpen,
    component: ModalComponent,
    props,
  } = useAppSelector((state) => state.genericModal);

  const handleClose = () => {
    dispatch(closeModal());
  };

  if (!isOpen || !ModalComponent) {
    return null;
  }

  return (
    <ModalWrapper onClose={handleClose}>
      <ModalComponent {...props} />
    </ModalWrapper>
  );
};
